import { NotificationType } from '../stores/notificationsStore';

export const notificationMessage: Partial<{ [key in NotificationType]: string }> = {
  [NotificationType.ADD_TO_CART]: 'Added to Basket',
  [NotificationType.REMOVED_FROM_CART]: 'Removed from Basket',
};
